import React from 'react';
import Sidebar from './Sidebar';

export default function PrivacyPolicyPage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white md:px-6 lg:px-10 max-w-7xl">
      <Sidebar />
      <div className="flex-1 p-4 lg:p-8">
        <h1 className="text-3xl md:text-5xl leading-14 font-axi-bold my-5">
          Privaatsuspoliitika
        </h1>
        <p className="text-base leading-6 mx-0 my-2">
          Osaühing Rademar jaoks on oluline Teie privaatsus ja järgida kõiki
          kehtivaid seadusi ja määrusi mis tahes isikuandmete kohta, mida võime
          Teie kohta koguda, kui külastate meie veebilehte{' '}
          <a href="https://www.rademar.ee/" className="text-rgreen underline">
            rademar.ee
          </a>
          . Meie veebisaiti kasutades nõustute, et kogume ja kasutame Teie
          andmeid vastavalt käesolevale privaatsuspoliitikale.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Käesoleva privaatsuspoliitikaga soovime Teile selgitada, milliseid
          andmeid me kogume, kuidas neid kasutame ja millised on Teie õigused
          oma andmete kaitsmiseks. Poliis rakendub ainult meie veebilehele ja
          selle külastajatele ning ei rakendu andmetele, mida kogutakse muude
          kanalite kaudu.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Teie andmete töötleja andmed:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">Rademar OÜ;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Värvi 14, Tallinn 10621;
          </li>
          <li className="text-base leading-6 mx-0 my-2">Reg. nr 10235879;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Telefon
            <a
              className="ml-2 underline font-axi-book text-rgreen"
              href="tel:+372 61 541 30"
            >
              +372 61 541 30;
            </a>
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            E-post
            <a
              className="ml-2 underline font-axi-book text-rgreen"
              href="mailto:info@rademar.ee"
            >
              info@rademar.ee.
            </a>
          </li>
        </ul>
        <p className="text-base leading-6 mx-0 my-2">
          Kogume ja töötleme teavet kooskõlas Euroopa Liidu üldise andmekaitse
          määrusega (GDPR), mis jõustus 25.05.2018.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Andmete kogumine ja kasutamine
        </h2>
        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Milliseid andmeid me kogume?
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Kogutav teave hõlmab nii teavet, mida Te meile teadlikult ja
          aktiivselt edastate meie teenuste või kampaaniate kasutamisel või
          nendes osalemisel, kui ka kogu teavet, mille Teie seadmed saadavad
          meie toodetele ja teenustele juurde pääsemisel.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Meie poolt kogutavad andmed sisaldavad endas teavet, mida olete meie
          teenuste või kampaaniate kasutamisel meile teadlikult jaganud ning
          teavet, mida Teie seadmed meile automaatselt edastavad.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Teie isiklikud andmed võivad jõuda meieni järgmistel viisidel:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Kui teete tellimuse{' '}
            <a href="https://www.rademar.ee/" className="text-rgreen underline">
              rademar.ee
            </a>{' '}
            e-poes;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui registreerite end{' '}
            <a href="https://www.rademar.ee/" className="text-rgreen underline">
              rademar.ee
            </a>{' '}
            e-poe kasutajaks;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui kontakteerute meiega telefoni, e-posti või online vestluse
            kaudu;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui ostate toote järelmaksuga ja sõlmite liisingulepingu;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui sirvite veebilehte{' '}
            <a href="https://www.rademar.ee/" className="text-rgreen underline">
              rademar.ee
            </a>
            ;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui esitate isiklikke andmeid teise isiku kohta, kes kauba vastu
            võtab;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui teete makseid kasutades e-panka või muud elektroonilist
            maksemeetodit;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui Te kommenteerite, laigite või jagate mõnda postitust meie
            sotsiaalmeedia kontol;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui liitute meie uudiskirjaga;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kui kommenteerite meie veebilehel olevaid postitusi.
          </li>
        </ul>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Kogutavad andmetüübid
        </h3>
        <h4 className="text-base leading-8 font-axi-bold mt-2">Isikuandmed</h4>
        <p className="text-base leading-6 mx-0 my-2">
          Küsime Teilt isiklikku informatsiooni ainult siis, kui see on vajalik
          Teile teenuse osutamiseks. Võttes meiega ühendust või külastades meie
          veebilehte, on võimalik, et jagate meiega järgnevat teavet:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Ees- ja perekonnanimi;
          </li>
          <li className="text-base leading-6 mx-0 my-2">E-posti aadress;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Postiaadress, riik, maakond, linn;
          </li>
          <li className="text-base leading-6 mx-0 my-2">Telefoninumber;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Teie ostuajalugu ja tegevus meie e-poes.
          </li>
        </ul>

        <h4 className="text-base leading-8 font-axi-bold mt-2">Logifailid</h4>
        <p className="text-base leading-6 mx-0 my-2">
          Meie veebileht{' '}
          <a href="https://www.rademar.ee/" className="text-rgreen underline">
            rademar.ee
          </a>{' '}
          salvestab oma külastajate kohta logifaile. Kogutava teabe hulka võib
          kuuluda:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Kasutatava seadme tüüp;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Interneti-protokolli (IP) aadress;
          </li>
          <li className="text-base leading-6 mx-0 my-2">Brauseri tüüp;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Internetiteenuse pakkuja (ISP);
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Veebilehe külastamise kuupäev ja kellaaeg;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Sisenemis- ja väljumisleht veebilehel tehtavate klikkide arv.
          </li>
        </ul>
        <p className="text-base leading-6 mx-0 my-2">
          Logifailides olevat informatsiooni kasutatakse trendide
          analüüsimiseks, veebilehe administreerimiseks, lehe külastajate
          tegevuste jälgimiseks ning demograafilise info kogumiseks. Saadud
          teabe ei ole mõeldud, ega võimaldagi isikut identifitseerida.
        </p>

        <h4 className="text-base leading-8 font-axi-bold mt-2">Küpsised</h4>
        <p className="text-base leading-6 mx-0 my-2">
          Nagu enamus veebilehti, kasutab ka{' '}
          <a href="https://www.rademar.ee/" className="text-rgreen underline">
            rademar.ee
          </a>{' '}
          "küpsiseid". Küpsis on sisuliselt tekstifail, mis salvestatakse
          veebisaidi külastamisel kasutaja seadmesse. Küpsiste abil määratakse
          ja salvestatakse eelistused, regionaalsed sätted, teenuste kasutamise
          valikud jpm.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Soovi korral võite brauseri seadistuses ära keelata küpsiste
          kasutamise, kuid sel juhul on võimalik, et Teile pakutav teenus on
          häiritud.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Küpsised jaotuvad püsi- ja sessiooniküpsisteks. Püsiküpsised jäävad
          Teie personaalarvutisse või mobiilseadmesse ka peale seda, kui olete
          sulgenud brauseri või arvuti. Sessiooniküpsised kustutatakse aga kohe
          pärast brauseri sulgemist.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Küpsised jagunevad oma eesmärgi järgi:
        </p>
        <h5 className="text-base leading-6 mx-0 my-2 font-axi-bold">
          Vajalikud küpsised.
        </h5>
        <p className="text-base leading-6 mx-0 my-2">
          Sessiooniküpsised, mille eesmärgiks on võimaldada Teile meie
          veebisaidil pakutavate teenuste kasutamist. Need küpsised aitavad
          kasutajaid autentida ja vältida kasutajakontode pahatahtlikku
          kasutamist. Ilma nende küpsisteta ei saa me Teile soovitud teenuseid
          pakkuda.
        </p>
        <h5 className="text-base leading-6 mx-0 my-2 font-axi-bold">
          Teavitusküpsised.
        </h5>
        <p className="text-base leading-6 mx-0 my-2">
          Need küpsised tuvastavad, kas kasutajad on veebisaidil küpsiste
          kasutamist aktsepteerinud.
        </p>
        <h5 className="text-base leading-6 mx-0 my-2 font-axi-bold">
          Funktsionaalsuse küpsised.
        </h5>
        <p className="text-base leading-6 mx-0 my-2">
          Need küpsised võimaldavad Teie brauseril meeles pidada valikuid, mida
          teete veebisaidi kasutamisel, näiteks Teie sisselogimisandmete või
          keele-eelistuste salvestamine. Nende küpsiste eesmärk on pakkuda Teile
          personaalsemat kogemust ja vältida eelistuste uuesti sisestamist.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Kuidas me andmeid kasutame?
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Kogutud informatsiooni võime kasutada erinevatel eesmärkidel,
          sealhulgas:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Meie veebilehe hooldamiseks, haldamiseks, arendamiseks,
            personaliseerimiseks ja laiendamiseks.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Statistika kogumiseks, et saaksime pakkuda paremaid teenuseid ja/või
            pakkumisi ning mõista ja analüüsida meie veebilehe külastajate
            käitumist.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Teie tuvastamiseks telefoni, sõnumi või e-posti teel.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Teile informatsiooni saatmisel ja meie teenuste kohta tagasiside
            palumisel.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Pettuste vältimiseks ja meie veebilehe kaitsmiseks.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Võimaldamaks meil Teiega ühenduses olla sotsiaalmeedia konto kaudu.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Vestlusajaloo lugemise võimaldamiseks, et kiirendada asjakohase nõu
            andmist.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Eesmärgiga parandada meie teenuse kvaliteeti ja pakkuda tõhusamaid
            sirvimislahendusi.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Et arendada uusi uusi tooteid, teenuseid või parandada nende
            funktsionaalsust.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kauba saatmiseks/kättetoimetamiseks, tellimuste töötlemiseks, arvete
            vormistamiseks, pangalingi kaudu tellimiseks ja Teie tellimuse
            kinnitamiseks või raha tagastamiseks.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Teie eelnevaid tellimusi arvesse võttes Teile huvi pakkuda võivate
            toodete ja teenuste pakkumine.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Meievaheliste interaktsioonide lihtsustamiseks ja kiirendamiseks,
            kui võtate meiega ühendust.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Muudel eesmärkidel. Näiteks andmete analüüsimiseks, trendide
            uurimiseks, meie reklaamikampaaniate tõhususe hindamiseks.
          </li>
        </ul>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Millistel juhtudel on võimalik, et jagame Teie andmeid?
        </h3>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Võime jagada või edastada Teie isikuandmeid seoses meie ettevõtte
            omanike vahetuse, ühinemise, varade müügi, finantseerimise või
            omandamise käigus. Teavitame Teid Teie isikuandmete edastamisest ja
            sellest, kui neile hakkavad kehtima mõne teise privaatsuspoliitika
            sätted.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Võime jagada Teie andmeid oma partnerettevõtetega, nõudes neilt
            käesoleva privaatsuspoliitika järgimist. Partnerettevõtete hulka
            kuuluvad meie ema- ja tütarettevõtted, ühisettevõtte partnerid või
            ettevõtted, mis kuuluvad meile.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Võime jagada Teie andmeid oma äripartneritega, et pakkuda Teile
            teatud tooteid, teenuseid või kampaaniaid.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Võime Teie nõusolekul avaldada Teie isikuandmeid mis tahes muul
            eesmärgil.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Oleme kohustatud Teie isikuandmed avaldama, kui seda nõuab seadus.
            Heas usus võime avaldada ka Teie andmeid, et järgida seadusest
            tulenevat kohustust, kaitsta meie õigusi või omandit, ennetada või
            tuvastada võimalikke meie teenuse kasutamisega seonduvaid
            õigusrikkumisi ja tagada teenuse kasutajate turvalisus.
          </li>
        </ul>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Teie isikuandmete säilitamine
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Ettevõte säilitab Teie isikuandmeid ainult seni, kuni see on vajalik
          käesolevas privaatsuspoliitikas sätestatud eesmärkidel. Säilitame ja
          kasutame Teie isikuandmeid ulatuses, mis on vajalik meie juriidiliste
          kohustuste täitmiseks (näiteks kui peame Teie andmeid säilitama
          kehtivate seaduste järgimiseks), vaidluste lahendamiseks ning meie
          juriidiliste lepingute ja eeskirjade jõustamiseks.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Ettevõte säilitab logifaile ka siseanalüüsi eesmärgil. Logifaile
          säilitatakse tavaliselt lühemat aega, välja arvatud juhul, kui neid
          andmeid kasutatakse turvalisuse tugevdamiseks või meie teenuse
          funktsionaalsuse parandamiseks või kui me oleme seadusega kohustatud
          neid andmeid pikemaks ajaks säilitama.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Laste andmete töötlemine
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Ükski meie toode või teenus ei ole suunatud alla 13-aastastele lastele
          ja me ei kogu teadlikult alla 13-aastaste laste andmeid. Kahtluse
          korral, et töötleme alla 13-aastase isiku andmeid, eemaldame selle
          isiku kõigist meie andmebaasidest.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Teie õigused oma andmete kaitsmiseks
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Teil on alati õigus oma andmeid meiega mitte jagada, teadmisega, et
          see võib mõjutada Teie kogemust meie veebisaidil. Kui otsustate oma
          andmeid meiega mitte jagada, ei kohtle me Teid seepärast halvemini.
          Kui edastate meile isiklikku teavet, mõistate, et kogume, hoiame,
          kasutame ja avaldame seda vastavalt käesolevale privaatsuspoliitikale.
          Teil on õigus nõuda Teie kohta kogutavate andmete üksikasju.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Saades Teie kohta isiklikku teavet kolmandalt osapoolelt, kaitseme
          seda vastavalt käesolevale privaatsuspoliitikale ja Eesti Vabariigi
          seadusele. Kui jagate ise kolmanda osapoole andmeid, kinnitate, et
          Teil on selleks ka õigus ja luba.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Isegi kui olete varem andnud nõusoleku meiega oma isiklikke andmeid
          turunduse eesmärkidel jagada, jääb Teile õigus igal ajal oma meelt
          muuta. Teil on alati õigus loobuda meiega suhtlemisest ja nõuda, et
          eemaldaksime Teie andmed meie andmebaasidest. Aeg-ajalt võime ka
          küsida Teie kohta teavet Teie isiku kinnitamiseks. Kui leiate, et
          andmed, mida Teie kohta kogunud oleme, on ebatäpsed, aegunud,
          puudulikud, ebaolulised või eksitavad, palun võtke meiega ühendust
          e-posti teel:{' '}
          <a className="underline text-rgreen" href="mailto:info@rademar.ee">
            info@rademar.ee.
          </a>{' '}
          Teeme kõik meist oleneva, et parandada ebatäpset, puudulikku,
          eksitavat või aegunud teavet.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Kui arvate, et oleme rikkunud asjakohast andmekaitseseadust ja soovite
          esitada kaebuse, palun võtke meiega ühendust, kasutades käesolevast
          dokumendist leitavaid kontaktandmeid ja edastage meile kõik rikkumise
          kohta käivad üksikasjad. Uurime Teie kaebust viivitamata ja vastame
          teile kirjalikult, esitades uurimise tulemused ja toome välja sammud,
          mida Teie kaebuse lahendamiseks ette võtame. Samuti on Teil õigus
          pöörduda reguleeriva asutuse või andmekaitseasutuse poole.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          GDPR andmekaitseõigused
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Soovime olla veendunud, et olete teadlik kõigist oma
          andmekaitseõigustest. Igal lehe kasutajal on õigus järgmistele
          tingimustele:
        </p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Juurdepääsuõigus - teil on õigus nõuda oma isikuandmete koopiaid.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Õigus andmete parandustele - teil on õigus nõuda, et parandaksime
            Teie arvates ebatäpsed andmed. Samuti on teil õigus nõuda, et
            täiendaksime andmeid, mis on Teie arvates puudulikud.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kustutamisõigus - teatud tingimustel on teil õigus nõuda Teie
            isikuandmete kustutamist.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Andmete töötlemise piiramise õigus - teatud tingimustel on teil
            õigus nõuda Teie isikuandmete kasutamise piiramist.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Õigus vaidlustada isikuandmete kasutamine - teatud tingimustel on
            teil õigus vaidlustada Teie isikuandmete kasutamine.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Õigus andmete teisaldatavusele - teatud tingimustel on teil õigus
            nõuda, et me edastaksime kogutud andmed kolmandale osapoolele või
            otse teile.
          </li>
        </ul>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Teie andmete turvalisus
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Teie isikuandmete turvalisus on meie jaoks oluline, kuid pidage
          meeles, et ükski Interneti-teel info vahetamise viis ega
          elektrooniline salvestusmeetod pole 100% turvaline. Kuigi anname
          endast kõik, et kaitsta Teie andmeid, ei saa me tagada nende täielikku
          turvalisust.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Osaühing Rademar võtab ette kõik mõistlikult vajalikud meetmed, et
          tagada Teie andmete töötlemine turvaliselt ja kooskõlas käesoleva
          privaatsuspoliitika ning Eesti Vabariigi seadusega. Teie andmeid ei
          edastata ühelegi organisatsioonile ega riigile, välja arvatud juhul,
          kui selleks on mõjuv põhjus ja on tagatud Teie andmete turvalisus.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Viitamine teistele veebisaitidele
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Meie veebisaidilt võite leida linke teistele veebilehtedele, mis ei
          kuulu meile. Kui vajutate kolmanda osapoole lingil, suunatakse teid
          selle kolmanda osapoole saidile. Soovitame tungivalt tutvuda iga
          külastatava saidi privaatsuseeskirjaga.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Me ei oma mingit kontrolli kolmandate osapoolte saitide üle ega võta
          vastutust nende sisu, privaatsuspoliitika, pakutavate teenuste või muu
          eest.
        </p>

        <h3 className="text-xl leading-10 font-axi-bold mt-3">
          Privaatsuspoliitika uuendused
        </h3>
        <p className="text-base leading-6 mx-0 my-2">
          Vajadusel on meil õigus teha käesolevale privaatsuspoliitika
          dokumendile muudatusi. Privaatsuspoliitika uuenemise järel muudame me
          selle allosas paiknevat dokumendi värskendamise kuupäeva. Kui
          külastate ja kasutate meie veebilehte ka pärast privaatsuspoliitika
          uuendamist, käsitleme me seda kui Teie vaikivat nõusolekut
          muudatustega.
        </p>
        <br />
        <p className="text-base leading-6 mx-0 my-2">
          Viimati muudetud 19/03/2024
        </p>
      </div>
    </div>
  );
}
